<template>
    <validation-provider
        v-if="!localRemoved"
        :id="fieldsetId"
        tag="div"
        :rules="localRules"
        :name="label"
        mode="eager"
        :disabled="localDisabled"
        class="form-group val-provider-outer mb-0"
        :class="[inline ? 'd-flex' : 'd-block', localDisplayMode ? 'spl-formcomps-displaymode' : 'spl-formcomps-editmode', {'spl-formcomps-disabled': localDisabled}]"
        :vid="localVid"
        ref="validationProvider"
        v-slot="{ errors, required, passed, failed, pending }"
    >
        <div 
            :class="inline ? 'mb-0' : 'mb-1'"
            :style="{width: localLabelWidth}"
        >  <!-- LEFT SIDE OF INLINE -->
            <label 
                :id="labelId"
                class="spl-formcomps-label d-block mb-0 font-weight-bold font-size-80 d-flex align-items-center"
                :style="inline ? 'line-height: 1.5; min-height: 2.5rem;' : ''"
                :class="labelClass"
                :for="inputId"
            >  <!-- make sure min-height matches the height of standard input, at least for inline mode -->
                <span>{{ label }}</span>
                <!-- <span class="text-muted small ml-2">{{ name }} - {{ level }}</span> -->
                <span v-if="required && !localDisabled" class="text-danger ml-1">*</span>
                <b-icon v-if="passed && !localDisabled" key="isPassed" icon="check-circle" variant="success" class="ml-2"></b-icon>
                <b-icon v-else-if="failed && !localDisabled" key="isFailed" icon="x-circle" variant="danger" class="ml-2"></b-icon>
            </label>
            <small 
                v-if="helpAbove || inline" 
                :id="helpId"
                class="form-text text-muted"
                :class="helpClass"
            >{{ help }}</small>  <!-- only show here for inline for certain input types....? -->
        </div>
        <div 
            class="w-100"
            :class="{  // put these on wrapper div instead?
                'spl-formcomps-passed': passed,
                'spl-formcomps-failed': failed,
                'spl-formcomps-required': required,
                'spl-formcomps-pending': pending,
            }"
        >  <!-- RIGHT SIDE OF INLINE -->
            <CustomFormCompGroup
                v-if="isGroupField"
                ref="groupField"
                :id="inputId"
                :name="name"
                v-model="currentValue"
                v-bind="inputComponentProps"
                :children="children"
                :level="level"
                :disabled="localDisabled"
                class="spl-formcomps-input"
                :class="inputClass"
            ></CustomFormCompGroup>  <!-- had this before: @input="handleBlur"  - get real blur handling working on group, if you will use that -->
            <!-- TODO TODO TODO  instead of v-model - use @input to some method that runs any fromComponentValue method for this inputDef, and calls validation manually using  const { valid } = await this.$refs.provider.validate(e); -->
            <component
                v-if="!localDisplayMode && inputDef.inputComponent"
                :key="`${type}-input`"
                :is="inputDef.inputComponent"
                :id="inputId" 
                v-model="currentValue"
                v-bind="inputComponentProps"
                :disabled="localDisabled"
                class="spl-formcomps-input w-100"
                :class="localInputClass"
                :placeholder="placeholder"
                @blur="handleBlur"
            ></component>
            <component
                v-if="localDisplayMode && (inputDef.displayComponent || inputDef.inputComponent)"
                :key="`${type}-display`"
                :is="inputDef.displayComponent || inputDef.inputComponent"
                :id="inputId" 
                :value="currentValue"
                v-bind="displayComponentProps"
                :disabled="localDisabled"
                class="spl-formcomps-input w-100"
                :class="localDisplayClass"
                :placeholder="displayModePlaceholder"
            ></component>
            <!-- <PrimeTextarea
                v-else-if="(type === 'textarea') && !localDisplayMode"
                key="textarea-input"
                :id="inputId" 
                v-model="currentValue"
                v-bind="inputComponentProps"
                :disabled="localDisabled"
                class="spl-formcomps-input w-100"
                :class="inputClass"
                :placeholder="localDisplayMode ? displayModePlaceholder : placeholder"
                @blur="handleBlur"
            ></PrimeTextarea> -->
            <!-- <div 
                v-else-if="(type === 'textarea') && localDisplayMode"
                key="textarea-display"
            >{{ currentValue }}</div> -->
            <!-- date / time - might need special rules that work with PrimeCalendar - can use props minDate, maxDate, disabledDates, disabledDays, and other props  -->
            <!-- NOTE - with PrimeCalendar, the value is ALWAYS JS Date() instance, in UTC.  But displays in local TZ.  That can cause issues when used to pick a date instead of datetime 
                    - also, week numbers are NOT CORRECT, might depend on which day of week is shown first, Sunday or Monday
            -->
            <!-- <PrimeCalendar
                v-else-if="(['date', 'datetime', 'time', 'month', 'year']).includes(type)"
                :key="`${type}-input`"
                :id="inputId" 
                v-model="currentValue"
                v-bind="inputComponentProps"
                :selectionMode="'single'"
                :view="type === 'month' ? 'month' : (type === 'year' ? 'year' : 'date')"
                :showIcon="true"
                :dateFormat="'M d, yy'"
                :icon="type === 'time' ? 'pi pi-clock' : 'pi pi-calendar'"
                :showTime="['datetime', 'time'].includes(type)"
                :timeOnly="type === 'time'"
                hourFormat="12"
                :manualInput="false"
                :disabled="localDisabled"
                class="spl-formcomps-input w-100"
                :class="inputClass"
                :placeholder="localDisplayMode ? displayModePlaceholder : placeholder"
                @blur="handleBlur"
            ></PrimeCalendar> -->
            <!-- <PrimeInputText
                v-else
                :id="inputId"
                :type="type"
                v-model="currentValue"
                v-bind="inputComponentProps"
                :disabled="localDisabled"
                class="spl-formcomps-input w-100"
                :class="inputClass"
                :placeholder="localDisplayMode ? displayModePlaceholder : placeholder"
                @blur="handleBlur"
            ></PrimeInputText> -->
            <!-- <textarea
                v-else-if="type === 'textarea'"
                :id="inputId" 
                v-model="currentValue"
                @input="handleBlur"
                rows="10"
                :disabled="localDisabled"
                class="spl-formcomps-input"
                :class="inputClass"
                :placeholder="placeholder"
            ></textarea> -->
            <!-- <input
                v-else
                :id="inputId"
                :type="type"
                v-model="currentValue"
                :disabled="localDisabled"
                class="form-control spl-formcomps-input"
                :class="inputClass"
                :placeholder="placeholder"
                @blur="handleBlur"
            /> -->
            <small 
                v-if="!inline && !helpAbove" 
                :id="helpId"
                class="form-text text-muted"
                :class="inputClass"
            >{{ help }}</small>
            <div 
                v-if="!localDisabled"
                :id="errorId"
                class="text-danger"
                :class="errorClass"
            >
                <small v-for="errMsg in errors" :key="errMsg">{{ errMsg }}</small>
            </div>
        </div>
    </validation-provider>
</template>

<script>
import uniqueId from "lodash/uniqueId";
import CustomFormCompGroup from "./CustomFormCompGroup.vue";
import inputProps from './custom_form_comp_input_props';
import { currentUserInfoMixin, tenantInfoMixin } from '../../js/custom-vue-mixins';
import { inputDefsByKey } from './custom_form_inputs';
// DO NOT NEED INDIVIDUAL COMPONENTS IMPORTED IF YOU IMPORT THEM AND PROVIDE THEM IN YOUR LOOKUPS
// import PrimeInputText from 'primevue/inputtext';
// import PrimeTextarea from 'primevue/textarea';
// import PrimeInputNumber from 'primevue/inputnumber';
// import PrimeInputMask from 'primevue/inputmask';
// import PrimeCalendar from 'primevue/calendar';
// import PrimeCheckbox from 'primevue/checkbox';
// import PrimeRadioButton from 'primevue/radiobutton';
// import PrimeSelectButton from 'primevue/selectbutton';
// import PrimeInputSwitch from 'primevue/inputswitch';
// import PrimeToggleButton from 'primevue/togglebutton';
// import PrimeAutoComplete from 'primevue/autocomplete';
// import PrimeMultiSelect from 'primevue/multiselect';
// import PrimeListbox from 'primevue/listbox';
// import PrimeCascadeSelect from 'primevue/cascadeselect';
// import PrimeDropdown from 'primevue/dropdown';
// import PrimeRating from 'primevue/rating';
// import PrimeSlider from 'primevue/slider';
// import PrimeEditor from 'primevue/editor';  // could be huge... uses Quill

// must have validation-provider as a global component, likely in the django template from script tag
// v-bind="$attrs" doesn't seem to pass anything on, if this was made in createElement() - that likely doesn't pass on the extra props as $attrs

/* const inputTypes = [
    {key: 'text', component: PrimeInputText},
    {key: 'textarea', component: PrimeTextarea},
    {key: 'text', component: PrimeInputNumber},
    {key: 'text', component: PrimeInputMask},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
    {key: 'text', component: PrimeInputText},
] */

// maybe make a function that takes the props / some standard object, then returns the component to use and final props
// can use this also for read-only / display-mode -- just return different component to use


export default {
    name: "CustomFormCompInput",
    components: {
        //ValidationProvider
        CustomFormCompGroup,
        // PrimeInputText,
        // PrimeTextarea,
        // PrimeInputNumber,
        // PrimeInputMask,
        // PrimeCalendar,
        // PrimeCheckbox,
        // PrimeRadioButton,
        // PrimeSelectButton,
        // PrimeInputSwitch,
        // PrimeToggleButton,
        // PrimeAutoComplete,
        // PrimeMultiSelect,
        // PrimeListbox,
        // PrimeCascadeSelect,
        // PrimeDropdown,
        // PrimeRating,
        // PrimeSlider,
        // PrimeEditor,
    },
    mixins: [
        currentUserInfoMixin,
        tenantInfoMixin,
    ],
    props: {
        ...inputProps,
        /* value: {
            required: false,  // set it differently for each type, use localValue???
        },
        rules: { // we merge this with other things, and pass localRules to input
            type: [String, Object],
            default: "",
        },
        required: {  // boolean, OR json-logic object
            // WARNING - read the docs on vee-validate required - there are many types of required
            type: [Object, Boolean],
            default: false,
        },
        hidden: {  // boolean, OR json-logic object
            // hidden = still in data, but not visible
            type: [Object, Boolean],
            default: false,
        },
        removed: {  // boolean, OR json-logic object
            // removed = NOT in data, also not visible - but still in registry so we can intelligently hide/show it
            type: [Object, Boolean],
            default: false,
        },
        disabled: {  // boolean, OR json-logic object
            type: [Object, Boolean],
            default: false,
        },
        displayMode: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            required: true,
        },
        level: {  // passed in from schema parent - 0 is root
            type: Number,
            required: true, 
        },
        label: {
            type: String,
            default: "",
        },
        help: {
            type: String,
            required: false,
        },
        helpAbove: {
            type: Boolean,
            default: false,
        },
        // something about showing help text even in 'display' mode?
        placeholder: {
            type: String,
            default: "",
        },
        displayModePlaceholder: {  // placeholder JUST for displayMode = true
            type: String,
            default: "",  
        },
        vid: {  // maybe not needed????
            type: String,
            default: undefined,
        },
        type: {  // not relevant for some inputs -- just pass on all attrs?
            type: String,
            default: "text",
        },
        inline: {  // show it as INLINE (label/input) instead of stacked?  inline label width?
            type: Boolean,
            default: false,
        },
        labelWidth: {  // width of label for INLINE layout ONLY - '30%' or '2rem' or Number that gets used as a %
            type: [String, Number],
            default: '30%',
        },
        children: {  // schema children for GROUP fields, not actual input instances -- those are elsewhere
            type: Array,
            required: false,
        },
        ///// CLASSES
        labelClass: {
            type: [String, Object, Array],
            default: '',
        },
        helpClass: {
            type: [String, Object, Array],
            default: '',
        },
        inputClass: {
            type: [String, Object, Array],
            default: '',
        },
        errorClass: {
            type: [String, Object, Array],
            default: '',
        }, */
    },
    data: () => ({
        // SCHEMA STUFF
        inputDef: null,  // set to the input def from lookup in created -- NOT REACTIVE??? 
        isGroupField: false,  // set true in created if we have type === 'group'
        // VALUE THINGS
        currentValue: "",
        localVid: "", // have to make a unique one
        // validation flags - basically just pulled out of validationProvider, but easily accessible by parent, etc. - or you could just have a method parent calls
        valid: null,   // does not actually mean its valid - need passed=true
        invalid: null,
        changed: null,
        dirty: null,
        passed: null,
        failed: null,
        // local values or props - need to re-calculate when props change (watcher) or when parent calls evaluateConditionals()?
        localRules: null,  // string or object?
        localHidden: false,  // from hidden prop, but always resolved to boolean
        localRemoved: false,  // from removed prop, but always resolved to boolean
        localDisabled: false,  // from disabled prop AND localDisplayMode, but always resolved to boolean
        localDisplayMode: false, // TODO - ADD THIS - from displayMode prop, but always resolved to boolean from possible conditional
        //localInputClass: '',  // we set these during updateValidation() - putting in computed has delayed update
        // lifecycle flags
        isMounted: false,  // set once in mounted()
    }),
    inject: [
        'foo',
        'getRootData',  // call this to get current data from root schema 
        'getRootContext',  // call this to get 'extra context' passed into root form
        'getParentData',  // call this to get data from parent schema (might be same as getRootData if field is top-level)
    ],
    computed: {
        isRemoved() {  // checked from parent?
            return this.localRemoved;
        },
        fieldsetId() {
            return `${this.localVid}-fieldset`;
        },
        inputId() {
            // the id="" attr for the input - MUST BE UNIQUE
            return `${this.localVid}-input`;
        },
        labelId() {
            // the id="" attr for the input - MUST BE UNIQUE
            return `${this.localVid}-label`;
        },
        helpId() {
            // the id="" attr for the input - MUST BE UNIQUE
            return `${this.localVid}-helptext`;
        },
        errorId() {
            // the id="" attr for the input - MUST BE UNIQUE
            return `${this.localVid}-errortext`;
        },
        localLabelWidth() {
            // check inline and labelWidth props to set final value of width in style object
            if (this.inline) {
                if (typeof this.labelWidth === 'number') {
                    return `${this.labelWidth}%`;
                } else if (typeof this.labelWidth === 'string') {
                    return this.labelWidth;
                } else {
                    return '30%';  // final default
                }
            } else {
                return '100%';
            }
        },
        inputComponentProps() {
            // any 'extra' attrs/props passed in... MERGED WITH the default/fixed props 
            // basically just this.$attrs - but we might need to inspect which props are available on the actual input component and pass them to it differently
            const defaultProps = this.inputDef?.inputDefaultProps || {};
            const fixedProps = this.inputDef?.inputFixedProps || {};
            const extraAttrs = this.$attrs || {};
            return Object.assign({}, defaultProps, extraAttrs, fixedProps);  // start with default, add the ones passed via schema, then override with fixed ones
        },
        localInputClass() {
            // merge inputClass prop with classes from inputDef
            const inputClassArray = this.inputClass ? (Array.isArray(this.inputClass) ? [...this.inputClass] : [this.inputClass]) : [];  // always an array, of valid stuff for :class
            const inputDefClass = this.inputDef?.inputClass ? (Array.isArray(this.inputDef.inputClass) ? [...this.inputDef.inputClass] : [this.inputDef.inputClass]) : [];
            return [...inputDefClass, ...inputClassArray];
        },
        displayComponentProps() {
            // any 'extra' attrs/props passed in... MERGED WITH the default/fixed props 
            // basically just this.$attrs - but we might need to inspect which props are available on the actual input component and pass them to it differently
            const defaultProps = this.inputDef?.displayDefaultProps || {};
            const fixedProps = this.inputDef?.displayFixedProps || {};
            const extraAttrs = this.$attrs || {};
            return Object.assign({}, defaultProps, extraAttrs, fixedProps);  // start with default, add the ones passed via schema, then override with fixed ones
        },
        localDisplayClass() {
            // merge inputClass prop with classes from inputDef (for display... use same as input if not provided?)
            const inputClassArray = this.inputClass ? (Array.isArray(this.inputClass) ? [...this.inputClass] : [this.inputClass]) : [];  // always an array, of valid stuff for :class
            const inputDefClass = this.inputDef?.displayClass ? (Array.isArray(this.inputDef.displayClass) ? [...this.inputDef.displayClass] : [this.inputDef.displayClass]) : [];
            return [...inputDefClass, ...inputClassArray];
        },
    },
    watch: {
        // need to watch `value` to watch for changes from external things (like setData on parent schema)
        // we just check if value changed, and if so, set currentValue to new value, then let watcher on that emit things to parent 
        value: function(val) {
            // IMMEDIATE ???  we may have that covered in created hook....
            this.setValue(val);
        },
        // watch currentValue (the actual internal value) to emit things to parent when changes happen
        currentValue: function (val) { // TODO - need to get from initial value
            // allows us to use v-model on our input.
            //console.log(`FROM WATCH ${this.name}`, val);
            // evaluateConditionals???
            const inputPayload = { field: this.name, value: val }; // validation status too???
            // add other things to payload?  removed?  validation?  hidden? 
            this.$emit("input", val);
            this.$emit("custom-input", inputPayload);
            this.updateValidation();
        },
        // watch props and set the local values using evaluateConditionals
        // should not need immediate: true on these -- we run evaluateConditionals in created() also
        rules: 'evaluateConditionals',
        required: 'evaluateConditionals',
        hidden: 'evaluateConditionals',
        removed: 'evaluateConditionals',
        disabled: 'evaluateConditionals',
        displayMode: 'evaluateConditionals',
    },
    created() {
        // have a 'getDefaultValue' that's based on the field type to get default when needed...
        // should we always set a currentValue, even if no value passed in???
        //console.log(`in CREATED hook for INPUT ${this.name} - this.value is`, this.value);
        // NOTE - this does NOT get called on re-render of the schema... only on initial created of this component
        this.isGroupField = this.type === 'group';
        this.inputDef = inputDefsByKey[this.type] ?? {};  // use empty object if there isn't one...  makes things easier
        if (this.value !== undefined) {
            // only do this if EXACTLY undefined... if null, we should use that as this.currentValue
            this.currentValue = this.value;
        } else {
            // should we ALWAYS do this if this.value is undefined???
            this.currentValue = this.getDefaultValue();
        }
        //this.currentValue = this.type === 'group' ? [] : '';
        this.localVid = `${this.name}_${uniqueId()}`;
        this.evaluateConditionals(); 
    },
    mounted() {
        // register with parent? 
        //const createdParams = { name: this.name, vid: this.localVid, component: this };
        this.isMounted = true;
        this.$emit('mounted', this);
    },
    methods: {
        setValue(val) {
            // set the value of this field (currentValue) -- likely from some outside thing?
            // maybe have different 'change detection' logic for different field types?  
            // need to check that new value is allowed???  have parsers for different field types....
            // if we pass in undefined, maybe that means we should reset to default value?  Or leave it undefined and when we emit @update then paret knows we should be left off data?
            // if we are a GROUP field, all rows get reset? handle that from watcher in group field?
            if (this.localRemoved) {
                // if we are REMOVED, then don't allow changing value externally
                // we do this so we keep the internal value before we were removed, so its there if we get unremoved
                return;
            }
            if (val !== this.currentValue) {
                const valStringified = JSON.stringify(val);
                const currentValStringified = JSON.stringify(this.currentValue);
                const stringifiedSame = valStringified === currentValStringified;
                console.log(`NEW VALUE SET ON ${this.name}, NOT EQUAL TO CURRENT VALUE, but stringifiedSame? ${stringifiedSame}`, val, this.currentValue, valStringified, currentValStringified);
                if (!stringifiedSame) {
                    this.currentValue = val;
                }
            }
            // then watcher for currentValue will take over, if we changed
            // evaluateConditionals???  or just do it in watcher for currentValue?
        },
        getDefaultValue() {
            // return the appropriate default / empty value for this field type, IF ANY
            // make this better in the future... get value from some lookup of types
            return this.type === 'group' ? [] : '';
        },
        handleBlur(evt) {
            this.$emit("blur", evt);
        },
        /* updateInputClass() {  // NOT REACTIVE ENOUGH -- maybe because you go through ref?
            // set these explicitly, not in computed... they are delayed
            // merge inputClass prop with other ones to show invalid status, etc.
            const inputClassArray = this.inputClass ? (Array.isArray(this.inputClass) ? [...this.inputClass] : [this.inputClass]) : [];  // always an array, of valid stuff for :class
            const failedClasses = ['p-invalid'];  // p-invalid is for PrimeVue inputs
            this.localInputClass = this.failed ? [...failedClasses, ...inputClassArray] : inputClassArray;
        }, */
        updateValidation() {
            console.log(`starting updateValidation on ${this.name}`);
            // call this on updates to own data - update own validation data things using ref on provider
            const flags = this.$refs.validationProvider?.flags ?? {};  // all the booleans, such as valid, invalid, touched, dirty, passed, failed, etc....
            // set defaults for these if we don't have validationProvider yet?
            this.valid = flags.valid;  // does not actually mean all good... must have passed=true, maybe other things
            this.invalid = flags.invalid;
            this.changed = flags.changed;
            this.dirty = flags.dirty;
            this.passed = flags.passed;
            this.failed = flags.failed;
            //this.updateInputClass();  // not reactive enough... maybe too slow going through $refs?
        },
        evaluateConditionals() {  // call this updateSelf?
            // called from parent (form schema)
            // evaluate all the conditional things, if any, to update any validation status
            // just update the local rules, hidden/removed, then call updateValidation() to set new flags
            //console.log('evaluateConditionals on', this.name);
            const evalContext = this.getConditionalEvalContext();
            // get evalContext once and pass to each one for efficiency
            this.setLocalRemoved(evalContext);
            this.setLocalHidden(evalContext);
            this.setLocalDisplayMode(evalContext);  // this must be resolved/set before setting localDisabled
            this.setLocalDisabled(evalContext);
            this.setLocalRules(evalContext);
            // TODO - need to evaluateConditionals of any children too!
            //      - should that happen before or after parent updates? 
            //      - maybe need to split how we update data and evaluate conditionals?
            //      - for groups, we'll set parent stuff first (above) then update the actual group field
            if (this.$refs.groupField) {
                const groupField = this.$refs.groupField;
                groupField.updateSelf();
                // make sure it is updated, and all children can react to the change
                // then tell it to emitInput so that currentValue HERE is updated
                groupField.emitInput();
            }
            // do this - updateValidation - no matter if we have conditionals or not?
            this.updateValidation();
            // then how does parent know if this input should be removed after evaluating conditionals?
            // maybe have some .getStatus() / .getValue() method that includes value, hidden, removed, etc...?
            // or just check localRemoved / isRemoved from parent?
            // getStatus/getValue could be good for getting calculated values...
        },
        setLocalRules(evalContext) {  // evalContext is optional here, will get if needed
            // evaluate conditionals and set final rules to pass to validation-provider
            // pass to validation-provider as an object -- vee-validate supports this
            // but if we have rules as a string, just pass that through for now
            const required = this.resolveConditional(this.required, evalContext);
            if (this.rules && typeof this.rules === 'string') {
                if (required) {
                    // make sure required is in the string
                    const splitRules = this.rules.split('|');  // if no | then it returns array with entire string, which is fine
                    if (!splitRules.includes('required')) {
                        this.localRules = 'required|' + this.rules;
                        return;  // we're done... stop here
                    }
                }
                this.localRules = this.rules;
                return;  // done, stop here
            }
            // EVALUATE THE RULES - RETURN RULES OBJECT (if you didn't have string rules prop)
            const rules = {};
            if (required) {
                rules['required'] = true;
            }
            this.localRules = rules;
        },
        setLocalHidden(evalContext) {
            this.localHidden = this.resolveConditional(this.hidden, evalContext);
        },
        setLocalRemoved(evalContext) {
            //this.localRemoved = this.resolveConditional(this.removed, evalContext);
            const finalEvalContext = evalContext || this.getConditionalEvalContext();
            const formData = finalEvalContext.data ?? {};
            if (this.name === 'last_field') {
                //console.log('formData from setLocalRemoved on last_field', formData);
                this.localRemoved = formData.field_one === 'something';
            } else {
                this.localRemoved = false;
            }
        },
        setLocalDisplayMode(evalContext) { // we may only use booleans in the prop... but adding this in case we want to do conditionals
            // NOTE - make sure to set this BEFORE setting localDisabled -- that depends on this (maybe use computed?)
            this.localDisplayMode = this.resolveConditional(this.displayMode, evalContext);
        },
        setLocalDisabled(evalContext) {
            const resolvedDisabled = this.resolveConditional(this.disabled, evalContext);
            this.localDisabled = resolvedDisabled || this.localDisplayMode;
        },
        resolveConditional(value, evalContext) {  // evalContext is optional, will get it here if needed
            // pass in the value of a SINGLE conditional prop, return the resolved value (boolean)
            let resolvedValue;  // undefined for now...
            if (value) {
                if (value === true || value === 'true') {
                    // if explicitly true, or string value 'true', then its required
                    // but if its an object, you likely need to check conditionals
                    resolvedValue = true;
                } else {
                    // if not explicitly true, then it's an object, should evaluate conditionals
                    const finalEvalContext = evalContext || this.getConditionalEvalContext();  // or pass it in?
                    console.log('TODO - run json-logic on this evalContext', finalEvalContext);
                    resolvedValue = true;  // just for now
                }
            } else {
                resolvedValue = false;
            }
            return resolvedValue;
        },
        getConditionalEvalContext() {
            const conditionalEvalContext = {
                data: this.getRootData(),
                context: this.getRootContext(),
                value: this.currentValue,
                currentUserInfo: this.$currentUserInfo,
                tenantInfo: this.$tenantInfo,
                // helper methods / lodash / splData / currentUserInfo / tenantInfo ???
            };
            if (this.level > 0) {
                conditionalEvalContext['row'] = this.getParentData();
                // is this always true? 
            }
            return conditionalEvalContext;
        },
        /* handleInput(evt) {
            this.$emit('input', evt);
        }, */
    },
};
</script>

<style lang="scss">

.spl-formcomps-editmode {
    .spl-formcomps-label {
        color: var(--gray-600);
    }
    input.p-component,
    textarea.p-component {
        // stuff for the input component itself - maybe add specificity with p-inputtext p-textarea, etc.
        &::placeholder {
            color: var(--gray-300);
        }
    }
}

.spl-formcomps-displaymode {
    .spl-formcomps-label {
        color: var(--gray-500);
    }
    .p-component:disabled {
        opacity: 1;  // normally .p-component:disabled has opacity of 0.6 -- but for displaymode, we want full opacity
    }
    input.p-component,
    textarea.p-component {  // might need to add more specificity
        background-color: rgba(255,255,255,0.9);
        border-color: transparent;
        color: #000;

        &::placeholder {
            color: var(--gray-300);
        }
    }
}

.spl-formcomps-input {
    //margin-top: 4px;
}

</style>